import React, { useState, useEffect, useRef } from "react";
import { css } from "styled-components/macro";
let initials = true;
function Stepper({ components, initialStep = 0 }) {
  if (initialStep) {
    initials = false;
  }
  let windowSize = window.innerWidth;
  let [current, set] = useState(initialStep);
  let temp = -current;
  const nextStep = () => {
    if (current < components.length - 1) {
      initials = false;
      set(prev => prev + 1);
    }
  };
  const prevStep = () => {
    if (current > 0) {
      initials = false;
      set(prev => prev - 1);
    }
  };
  return (
    <div
      css={css`
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
      `}
    >
      {components.map((Component, index) => {
        return (
          <div
            key={index}
            css={css`
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: ${(initials ? index : temp++) * windowSize}px;
              transition: 0.5s;
            `}
          >
            <Component
              nextStep={nextStep}
              prevStep={prevStep}
              isCurrent={current === index}
            ></Component>
          </div>
        );
      })}
    </div>
  );
}
function FileValidation(file, { size, type, typeTitle }) {
  if (size && file.size > size * 1000) {
    throw new Error(`حجم فایل باید کمتر از ${size}کیلوبایت باشد`);
  }
  if (type && file.type.split("/").indexOf(type) === -1) {
    throw new Error(`فرمت فایل انتخابی باید ${typeTitle} باشد`);
  }
}
function responseExtracor(raw) {
  return typeof raw === "string"
    ? raw.substr(0, raw.indexOf("<!DOCTYPE html>")).trim()
    : raw;
}
function useCountdown(m, s) {
  const [state, setState] = useState(m * 60 + s);
  const staticState = useRef({ counter: null, endedFn: null });
  useEffect(() => {
    if (state <= 0) {
      if (staticState.current.endedFn) {
        staticState.current.endedFn();
      }
      clearInterval(staticState.current.counter);
      setState(m * 60 + s);
    }
  }, [state]);
  function start() {
    staticState.current.counter = setInterval(() => {
      setState(prev => prev - 1);
    }, 1000);
  }
  function onEnded(Fn) {
    staticState.current.endedFn = Fn;
  }
  function GetTime(type) {
    let minutes = parseInt(state / 60, 10);
    let seconds = parseInt(state % 60, 10);
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;
    if (type === "raw") {
      return { m: minutes, s: seconds };
    } else {
      return `${minutes}:${seconds}`;
    }
  }
  return [start, GetTime, onEnded];
}
export { Stepper, FileValidation, responseExtracor, useCountdown };
